<template>
  <div id="header" class="header-fff">
    <div class="header-left">
      <router-link to="/" class="logo-href" @click.native="resource_loc_click('版权站LOGO')">
        <img class="logo-000" src="@/assets/image/common/logo1.png" />
      </router-link>
    </div>

    <div class="icon-box" v-if="headerShow">
      <img src="@/assets/image/common/hicon.png" />
      <shownav />
    </div>
    <div class="search-box" v-if="headerShow">
      <search />
    </div>
    <ul class="header-center" v-if="headerShow == false">
      <li @click="resource_loc_click('首页')">
        <router-link to="/" :class="
          navtxt == 'Index'
            ? 'router-link-exact-active router-link-active'
            : ''
        ">首页</router-link>
      </li>
      <li @click="resource_loc_click('图片')">
        <router-link to="/search" :class="
          navtxt == 'SearchPage'
            ? 'router-link-exact-active router-link-active'
            : ''
        ">版权图片</router-link>
      </li>
      <li @click="resource_loc_click('视频')">
        <router-link to="/video" :class="
          navtxt == 'VideoSearchPage'
            ? 'router-link-exact-active router-link-active'
            : ''
        ">版权视频</router-link>
      </li>
      <li><a :href="editorUrl + '/custom_shooting'" target="_blank">定制拍摄</a></li>
      <li><a :href="editorUrl" target="_blank">365编辑器</a></li>
    </ul>
    <div class="header-right">
      <router-link class="vip-btn l geren" to="/vip" target="_blank" @click.native="resource_loc_click('个人VIP')">
        <img class="logo-000" src="@/assets/image/common/vip-person1.png" alt="" /><img class="logo-fff"
          src="@/assets/image/common/vip-person.png" alt="" />个人VIP
      </router-link>
      <div class="collect-btn l" @click="gotoPage('/personal', '收藏夹')">
        <img class="logo-000" src="@/assets/image/common/collect1.png" alt="" /><img class="logo-fff"
          src="@/assets/image/common/collect.png" alt="" />收藏夹
      </div>
      <div class="login-btn r" v-if="!(staticFunc.isLogin() && loginInfo)" @click.stop="loginFn()">
        注册/登录
      </div>
      <div class="login-info r" v-else>
        <div class="img-box">
          <img v-if="loginInfo && loginInfo.headimg" :src="loginInfo.headimg" class="icon" alt="" />
          <img v-else src="@/assets/image/common/mobile_head.png" class="icon" alt="" />
          <img v-if="loginInfo.is_sc_vip > 0" src="@/assets/image/common/vip_icon.png" alt="" class="vip-icon" />
        </div>
        <div class="dropdown_area">
          <ul>
            <li>
              <div @click="gotoPage('/personal', '收藏夹')">
                <span class="iconfont icon-shoucangjia"></span><span>收藏夹</span>
              </div>
            </li>
            <li style="
                padding-top: 5px;
                margin-top: 5px;
                border-top: 1px solid #ebebeb;
              ">
              <div @click="gotoPage('/personal/order', '订单中心')">
                <span class="iconfont icon-dingdanzhongxin"></span><span>订单中心</span>
              </div>
            </li>
            <li>
              <div @click="gotoPage('/personal/record', '下载记录')">
                <span class="iconfont icon-xiazaijilu"></span><span>下载记录</span>
              </div>
            </li>
            <li style="
                padding-top: 5px;
                margin-top: 5px;
                border-top: 1px solid #ebebeb;
              ">
              <div @click="gotoPage('/personal/info', '账户信息')">
                <span class="iconfont icon-zhanghuxinxi"></span><span>个人信息</span>
              </div>
            </li>
            <li>
              <div @click="gotoPage('/personal/invoice', '申请发票')">
                <span class="iconfont icon-shenqingfapiao2"></span><span>申请发票</span>
              </div>
            </li>
            <li @click.stop="logout" style="
                padding-left: 30px;
                padding-top: 5px;
                margin-top: 5px;
                border-top: 1px solid #ebebeb;
              ">
              <span class="iconfont icon-tuichudenglu1"></span><span>退出登录</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <login-dialog v-if="$store.state.showLogin" ref="loginDialog" @close="$store.commit('watchShowLogin', false)" />


    <!-- 用户注册协议 -->
    <div class="userProtocol-mask" v-if="showProtocol">
      <div class="userProtocol">
        <div class="com-userProtocol">
          <div class="protocoltitle">
            <h2>365编辑器平台服务协议</h2><i class="icon-close iconfont" @click="showProtocol = false"></i>
          </div>
          <div class="item">
            <ul>
              <li class="title">一、特别提示</li>
              <li class="font">
                北京微梦传媒股份有限公司运营365编辑器（以下简称“本编辑器”），依据《北京微梦传媒股份有限公司服务协议》（以下简称“本协议”）的规定提供服务，本协议具有合同效力。用户注册时，请您认真阅读本协议，审阅并接受或不接受本协议（未成年人应在法定监护人陪同下审阅）。<br>若您已经注册为本编辑器用户，即表示您已充分阅读、理解并同意自己与本编辑器订立本协议，且您自愿接受本协议的条款约束。本编辑器有权随时变更本协议并在本编辑器上予以公告。经修订的条款一经在本编辑器的公布后，立即自动生效。如您不同意相关变更，必须停止使用本编辑器。本协议内容包括协议正文及所有365编辑器已经发布的各类规则。所有规则为本协议不可分割的一部分，与本协议正文具有同等法律效力。一旦您继续使用本编辑器，则表示您已接受并自愿遵守经修订后的条款。
              </li>
            </ul>
          </div>
          <div class="item">
            <ul>
              <li class="title">二、账号注册</li>
              <li class="font">
                1、用户在使用本服务前需要注册一个账号。账号可以使用微信/手机号/微博/QQ方式注册，用户完成注册申请手续后，获得365编辑器帐号的使用权。用户应提供及时、详尽及准确的个人资料，并不断更新注册资料，符合及时、详尽准确的要求。所有原始键入的资料将引用为注册资料。如果因注册信息不真实而引起的问题，并对问题发生所带来的后果，365编辑器不负任何责任。<br />2、如果注册申请者有被本编辑器封禁的先例或涉嫌虚假注册及滥用他人名义注册,
                及其他不能得到许可的理由,
                本编辑器将拒绝其注册申请。<br />3、鉴于本编辑器账号的绑定注册方式，您同意本编辑器在注册时允许您的手机号码及手机设备识别和微信/QQ/微博昵称、头像等信息用于注册。<br />4、用户不应将其帐号、密码转让、出售或出借予他人使用，若用户授权他人使用账户，应对被授权人在该账户下发生所有行为负全部责任。<br />5、365编辑器可能会与合作伙伴共同向您提供您所要求的服务或者共同向您展示您可能感兴趣的内容。在信息为该项产品/服务所必须的情况下，您同意365编辑器可与其分享必要的信息。并且，365编辑器会要求其确保数据安全并且禁止用于任何其他用途。除此之外，365编辑器不会向任何无关第三方提供或分享信息<br>6、在如下情况下，365编辑器可能会披露您的信息：<br />&nbsp;&nbsp;&nbsp;（1）事先获得您的授权；<br />&nbsp;&nbsp;&nbsp;（2）您使用共享功能；<br />&nbsp;&nbsp;&nbsp;（3）根据法律、法规、法律程序的要求或政府主管部门的强制性要求；<br />&nbsp;&nbsp;&nbsp;（4）以学术研究或公共利益为目的；<br />&nbsp;&nbsp;&nbsp;（5）为维护365编辑器的合法权益，例如查找、预防、处理欺诈或安全方面的问题；<br />&nbsp;&nbsp;&nbsp;（6）符合相关服务条款或使用协议的规定。<br />
              </li>
            </ul>
          </div>
          <div class="item">
            <ul>
              <li class="title">三、用户的权利与义务</li>
              <li class="font">
                1、用户一旦注册成功,成为本编辑器的用户,将得到登录授权,并有权登录随时使用本编辑器，根据本协议，使用本编辑器提供的服务。<br />2、用户对自己的登录账号的安全负全部责任，且须对在用户账号下发生的所有活动及所发布的内容承担责任。用户有权根据需要修改注册信息。因用户的过错导致的任何损失由用户自行承担，该过错包括但不限于：(不按照交易提示操作，未及时进行交易操作，遗忘或泄漏密码，密码被他人破解，您使用的计算机被他人侵入)。<br />3、用户不得以任何形式擅自转让或授权他人使用自己在本编辑器的用户账号，否则应自行承担由此引起的一切后果。<br />4、用户有义务确保在本编辑器上发布的内容信息真实、准确、合法、无误导性。<br />5、用户在本编辑器上发布的内容，不得违反国家法律、法规、行政规章的规定、不得侵犯他人知识产权或其他合法权益的信息、不得违背社会公共利益或公共道德、不得违反本编辑器的相关规定，如有违反导致任何法律后果的发生，用户将以自己的名义独立承担相应的法律责任。<br>6、用户使用本编辑器时应当遵守诚实信用原则，不得采取不正当竞争方式扰乱网上交易秩序，不得从事与网上交易无关的不当行为。<br />7、用户不应采取不正当手段提高自身或他人信用度，或采用不正当手段恶意评价其他用户，降低其他用户信用度，否则应自行承担由此引起的一切后果。<br />8、用户如发现其他用户有违法或违反本协议的行为，可以向本编辑器举报。<br>9、不利用365编辑器服务从事以下活动：<br />&nbsp;&nbsp;&nbsp;（1）未经允许，进入计算机信息网络或者使用计算机信息网络资源的；<br />&nbsp;&nbsp;&nbsp;（2）未经允许，对计算机信息网络功能进行删除、修改或者增加的；<br />&nbsp;&nbsp;&nbsp;（3）未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；<br />&nbsp;&nbsp;&nbsp;（4）故意制作、传播计算机病毒等破坏性程序的；<br />&nbsp;&nbsp;&nbsp;（5）其他危害计算机信息网络安全的行为。<br />10、用户不得实施以下不良行为：<br />&nbsp;&nbsp;&nbsp;（1）含有涉黄、涉暴、辱骂、恐吓、威胁内容;<br />&nbsp;&nbsp;&nbsp;（2）含有骚扰、垃圾广告、恶意信息、诱骗信息;<br />&nbsp;&nbsp;&nbsp;（3）涉及他人隐私、个人信息或资料;<br />&nbsp;&nbsp;&nbsp;（4）侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利;<br />&nbsp;&nbsp;&nbsp;（5）含有其他干扰本服务正常运营和侵犯其他用户或第三方合法权益的行为。<br />
              </li>
            </ul>
          </div>
          <div class="item">
            <ul>
              <li class="title">四、365编辑器的权利与义务</li>
              <li class="font">
                1、365编辑器网络服务的具体内容由365编辑器根据实际情况提供。<br />2、除非本服务协议另有其它明示规定，365编辑器所推出的新产品、新功能、新服务，均受到本服务协议之规范。<br />3、鉴于网络服务的特殊性，用户同意365编辑器有权不经事先通知，随时变更、中断或终止部分或全部的网络服务（包括收费网络服务）。365编辑器不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。<br />4、365编辑器需要定期或不定期地对提供网络服务的平台或相关的设备进行检修或者维护，如因此类情况而造成网络服务（包括收费网络服务）在合理时间内的中断，365编辑器无需为此承担任何责任。365编辑器保留不经事先通知为维修保养、升级或其它目的暂停本服务任何部分的权利。<br />5、365允许使用其它网站的网页、图片、视频等资源的外链。由于365编辑器无法控制这些外链内容，您了解并同意，此类网站或资源是否可供利用，365编辑器不予负责。存在或源于此类网站或资源之任何内容、广告、产品或其它资料，365编辑器亦不予保证或负责。因使用或依赖任何此类网站或资源发布的或经由此类网站或资源获得的任何内容、商品或服务所产生的任何损害或损失，365编辑器不承担任何责任。<br>6、用户明确同意其使用365编辑器网络服务所存在的风险将完全由其自己承担。用户理解通过365编辑器服务取得的任何信息资料取决于用户自己，并由其承担系统受损、资料丢失以及其它任何风险。365编辑器对在服务网上得到的任何商品购物服务、交易进程、招聘信息，都不作担保。<br />7、365编辑器有权于任何时间暂时或永久修改或终止本服务（或其任何部分），而无论其通知与否，365编辑器对用户和任何第三人均无需承担任何责任。<br />8、根据国家法律、法规、行政规章规定、本协议的内容和本编辑器所掌握的事实依据，可以认定该用户存在违法或违反本协议行为以及在本编辑器上的其他不当行为，本编辑器有权无需征得用户的同意随时作出删除相关信息、终止服务提供等处理。<br>
              </li>
            </ul>
          </div>
          <div class="item">
            <ul>
              <li class="title">五、服务的中断和终止</li>
              <li class="font">在下列情况下, 本编辑器有权终止向用户提供服务:<br />&nbsp;&nbsp;&nbsp;（1）在用户违反本服务协议相关规定时, 本编辑器有权终止向该用户提供服务;
                如该用户再一次直接或间接或以他人名义注册为用户的,一经发现,
                本编辑器有权直接单方面终止向该用户提供服务;<br />&nbsp;&nbsp;&nbsp;（2）一旦发现用户提供的数据或发布信息中含有虚假内容,本编辑器有权随时终止向该用户提供服务;<br />&nbsp;&nbsp;&nbsp;（3）本公司及本编辑器认为需终止服务的其它情况。<br />
              </li>
            </ul>
          </div>
          <div class="item">
            <ul>
              <li class="title">六、免责声明</li>
              <li class="font">
                当用户接受该协议时，用户应当明确了解并同意以下条款：<br />1、本编辑器不能随时预见到任何技术上的问题或其他困难，可能会导致数据损失或其他服务中断。本编辑器是在现有技术基础上提供的服务。本编辑器不保证以下事项∶<br />&nbsp;&nbsp;&nbsp;（1）本编辑器将符合所有用户的要求。<br />&nbsp;&nbsp;&nbsp;（2）本编辑器在任何情况下能够不受干扰、及时提供、安全可靠或免于出错。<br />&nbsp;&nbsp;&nbsp;（3）本服务使用权的取得结果是正确或可靠的。<br />2、是否经由本编辑器取得任何资料，由用户自行考虑、衡量并且自负风险，因获取的任何资料而导致用户电脑系统的任何损坏或资料流失，财产损失，用户应负完全责任。希望用户在使用本编辑器时，小心谨慎并运用常识。<br />3、用户经由本编辑器取得的建议和资讯，无论其形式或表现，绝不构成本协议未明示规定的任何保证。<br />4、基于以下原因而造成的利润、商誉、使用、资料损失或其它无形损失，本编辑器不承担任何直接、间接、附带、特别、衍生性或惩罚性赔偿（即使本编辑器已被告知前款赔偿的可能性）：<br />&nbsp;&nbsp;&nbsp;（1）本编辑器的使用或无法使用。<br />&nbsp;&nbsp;&nbsp;（2）用户的传输或资料遭到未获授权的存取或变更。<br />&nbsp;&nbsp;&nbsp;（3）本编辑器中任何第三方之声明或行为。<br />&nbsp;&nbsp;&nbsp;（3）本编辑器其它相关事宜。<br />5、本编辑器只是为用户提供一个服务平台，对于用户所发布的内容的合法性、真实性及其品质等，本编辑器一律不负任何担保责任。<br />6、本编辑器提供与其它互联网上的网站或资源的链接，用户可能会因此连接至其它运营商经营的网站，但不表示本编辑器与这些运营商有任何关系。其它运营商经营的网站均由各经营者自行负责，不属于本编辑器控制及负责范围之内。对于存在或来源于此类网站或资源的任何内容、广告、物品或其它资料，本编辑器亦不予保证或负责。因使用或依赖任何此类网站或资源发布的或经由此类网站或资源获得的任何内容、物品或服务所产生的任何损害或损失，本编辑器不负任何直接或间接的责任。<br />
              </li>
            </ul>
          </div>
          <div class="item">
            <ul>
              <li class="title">七、知识产权</li>
              <li class="font">
                1、本编辑器及本编辑器所使用的任何相关软件、程序、内容，包括但不限于作品、图片、资料、网站构架、设计、均由本编辑器或其它权利人依法享有相应的知识产权，包括但不限于著作权、商标权、专利权或其它专属权利等，受到相关法律的保护。未经本编辑器或权利人明示授权，用户保证不修改、出租、出借、出售、散布本编辑器及本编辑器所使用的上述任何资料和资源，或根据上述资料和资源制作成任何种类产品。<br />2、本编辑器授予用户不可转移及非专属的使用权，使用户可以通过PC端使用本编辑器，但用户不得且不得允许任何第三方复制、修改、创作衍生作品、进行还原工程、反向组译，或以其它方式破译或试图破译源代码，或出售、转让"软件"或对"软件"进行再授权，或以其它方式移转"
                软件"之任何权利。用户同意不以任何方式修改"软件"，或使用修改后的"软件"。<br />3、用户不得经由非本编辑器所提供的界面使用本编辑器。<br /></li>
            </ul>
          </div>
          <div class="item">
            <ul>
              <li class="title">八、不可抗力</li>
              <li class="font">
                因不可抗力或者其他意外事件，使得本协议的履行不可能、不必要或者无意义的，双方均不承担责任。本合同所称之不可抗力意指不能预见、不能避免并不能克服的客观情况，包括但不限于战争、台风、水灾、火灾、雷击或地震、罢工、暴动、法定疾病、黑客攻击、网络病毒、电信部门技术管制、政府行为或任何其它自然或人为造成的灾难等客观情况。
              </li>
            </ul>
          </div>
          <div class="item">
            <ul>
              <li class="title">九、保密</li>
              <li class="font">
                双方保证在对讨论、签订、执行本协议中所获悉的属于对方的且无法自公开渠道获得的文件及资料（包括但不限于商业秘密、公司计划、运营活动、财务信息、技术信息、经营信息及其他商业秘密）予以保密。未经该资料和文件的原提供方同意，另一方不得向第三方泄露该商业秘密的全部或者部分内容。但法律、法规、行政规章另有规定或者双方另有约定的除外。
              </li>
            </ul>
          </div>
          <div class="item">
            <ul>
              <li class="title">十、其他</li>
              <li class="font">
                1、本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。<br />2、如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向365编辑器所在地的人民法院提起诉讼。<br />3、365编辑器未行使或执行本服务协议任何权利或规定，不构成对前述权利或权利之放弃。<br />4、如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。<br />
              </li>
            </ul>
          </div>
          <div class="item">
            <ul>
              <li class="title">365编辑器对本服务及协议制定的各项规则拥有最终解释权。</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loginDialog from "@/components/loginDialog";
import Search from "@/components/searchHeard";
import shownav from "@/components/shownav";
import { Login } from "@/config/axios/api";
import { mapState } from "vuex";

export default {
  props: ["headerOpacity", "navtxt"],
  data () {
    return {
      showSwitchUser: false,
      showProtocol: false
    };
  },
  components: {
    loginDialog,
    Search,
    shownav,
  },
  computed: {
    ...mapState(['loginInfo', 'headerShow']),
  },
  created () {
    this.$store.commit("watchShowLogin", false);
    this.$store.commit("setHeaderShow", false);
    this.activeFun(this.$route.name);
    this.$bus.$on('changeShowProtocol', this.changeShowProtocol)
  },
  mounted () { },
  beforeDestroy () {
    this.$bus.$off('changeShowProtocol');
  },

  methods: {
    activeFun (name) {
      if (name == "SearchPage") {
        this.seachTypeData = "图片";
      } else if (name == "MusicSearchPage") {
        this.seachTypeData = "音乐";
      } else if (name == "DesignSearchPage") {
        this.seachTypeData = "设计";
      } else if (name == "VideoSearchPage") {
        this.seachTypeData = "视频";
      } else if (name == "ExemptPage") {
        this.seachTypeData = "免抠元素";
      } else if (name == "PptPage") {
        this.seachTypeData = "PPT模板";
      }
    },
    loginFn () {
      // 因为本地登陆cookie设置不上， 所以手动存cookie,
      if (process.env.NODE_ENV === "development") {
        this.staticFunc.setCookie("UserId", 3504558);
        this.staticFunc.setCookie("code", '223dea968a2d72eb7f02');
        this.staticFunc.setCookie("loginCode3504558", 'ded33a9cdf6c55a7ddd832adfebdbeee');    //每次登陆都不一样
        window.location.reload()
      }
      this.$store.commit("watchShowLogin", true);
    },
    //清除所有cookie函数
    clearAllCookie () {
      var date = new Date();
      date.setTime(date.getTime() - 10000);
      //keys为所要删除cookie的名字
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
      //删除所有cookie
      if (keys) {
        for (var i = keys.length; i--;)
          document.cookie =
            keys[i] +
            "=0; expire=" +
            date.toGMTString() +
            "; path=/;domain=" +
            document.domain;
      }
    },
    // 退出登录
    logout () {
      Login.loginout().then(res => {
        if (res.status == 1) {
          // 本地清除cookie
          if (process.env.NODE_ENV === "development") {
            this.staticFunc.setCookie('UserId', '')
          }
          this.$store.commit("setLoginInfo", null);
          window.localStorage.clear();
          window.sessionStorage.clear();
          location.href = process.env.VUE_APP_BASELogout;
        }
      })
    },

    gotoPage (path, type) {

      this.resource_loc_click(type);
      if (!this.staticFunc.isLogin()) {
        this.$store.commit("watchShowLogin", true);
        return;
      }
      if (this.$route.path.indexOf("/personal") >= 0) {
        this.$router.push(path);
      } else {
        window.open(path);
      }
    },
    resource_loc_click () {
      this.$store.commit("setHeaderShow", false);
    },
    changeShowProtocol (bool) {
      this.showProtocol = bool;
    },
  },
};
</script>

<style lang="scss">
#header {
  @include wh(100vw, 60px);
  min-width: 1000px;
  background: rgba(255, 255, 255, 0.06);
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.04);
  padding: 0 40px;
  position: fixed;
  top: 0;
  z-index: 20;

  .header-left {
    float: left;
    margin-top: 5px;
    position: relative;
    z-index: 1;

    .logo-href {
      @include wh(181px, 51px);
      float: left;

      img {
        display: block;
        width: 100%;
      }
    }
  }

  .logo-fff {
    display: inline-block;
  }

  .logo-000 {
    display: none;
  }

  .header-center {
    float: left;

    /* position: absolute;
        left: 0;
        right: 0;
        top: 0;
        margin-left: auto;
        margin-right: auto;
        text-align: center; */
    li {
      display: inline-block;
      position: relative;
      line-height: 60px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      transition: 0.3s;
      margin: 0 20px;

      a {
        color: #ffffff;
        position: relative;

        .new_icon {
          position: absolute;
          right: -25px;
          top: -2px;
          width: 22px;
        }
      }

      .router-link-exact-active::after {
        content: "";
        display: block;
        position: absolute;
        bottom: -9px;
        left: 0;
        width: 100%;
        height: 2px;
        background: #fff;
        border-radius: 2px;
      }

      &.active,
      &:hover {
        font-weight: 500;
        font-family: PingFangSC-Medium, PingFang SC;

        &::after {
          content: "";
          display: block;
          position: absolute;
          bottom: 8px;
          left: 0;
          width: 100%;
          height: 2px;
          background: #fff;
          border-radius: 2px;
        }
      }

      &.video {
        margin-left: 60px;
        margin-right: 46px;
      }
    }
  }

  .header-right {
    float: right;
    position: relative;

    .vip-btn,
    .collect-btn {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 62px;
      margin-right: 28px;
      cursor: pointer;
      position: relative;

      img {
        float: left;
        @include wh(16px, 16px);
        margin-right: 6px;
        margin-top: 23px;
      }

      .dbjb {
        position: absolute;
        left: 0;
        top: -21px;
        width: 100px;
        height: 18px;
      }

      .hover-img {
        display: none;
        position: absolute;
        left: 0;
        top: 34px;
        width: 240px;
        height: 224px;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.4);
      }
    }

    .geren {
      &:hover {
        .hover-img {
          display: block;
        }
      }
    }

    .qiye {
      &:hover {
        .hover-img {
          display: block;
        }
      }
    }

    .collect-btn {
      img {
        margin-top: 20px;
      }

      margin-right: 0;
    }

    .login-btn {
      cursor: pointer;
      // width: 96px;
      // height: 34px;
      // border-radius: 4px;
      margin: 0 12px 0 37px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      // text-align: center;
      font-size: 16px;
      color: #ffffff;
      line-height: 60px;
    }

    .login-info {
      padding: 11px 0 16px 28px;
      position: relative;

      .img-box {
        width: 38px;
        height: 38px;
        /* background: rgba(255, 255, 255, 0.3); */
        border-radius: 4px;
        overflow: hidden;
      }

      .icon {
        @include wh(38px, 38px);
        border-radius: 50%;
      }

      .vip-icon {
        @include wh(15px, 15px);
        position: absolute;
        right: 22px;
        top: 30px;
      }

      &:hover {
        .dropdown_area {
          display: block;
        }
      }

      .dropdown_area {
        display: none;
        position: absolute;
        right: 0;
        top: 60px;
        width: 140px;
        background: #ffffff;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
        border-radius: 14px;
        padding-top: 8px;
        padding-bottom: 8px;
        box-sizing: border-box;

        ul {
          width: 128px;
          margin: 0 auto;

          li {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #0a051b;
            line-height: 36px;
            cursor: pointer;

            a,
            div {
              padding-left: 30px;
              color: #0a051b;
              display: block;
              width: 100%;
              height: 100%;
            }

            span {
              margin-right: 6px;

              &::before {
                vertical-align: middle;
              }
            }

            &.active,
            &:hover {
              background: #f7f9fa;
              border-radius: 8px;
            }
          }
        }
      }
    }
  }

  // 不透明头部样式
  &.header-fff {
    @include wh(100vw, 60px);
    background: #ffffff;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.05);

    .logo-fff {
      display: none;
    }

    .logo-000 {
      display: inline-block;
    }

    .header-center {
      li {
        line-height: 60px;

        a {
          color: #1f1f1f;
        }

        &.active::after {
          content: "";
          display: block;
          position: absolute;
          bottom: 8px;
          left: 0;
          width: 100%;
          height: 2px;
          background: #1f1f1f;
          border-radius: 2px;
        }

        .router-link-exact-active::after {
          content: "";
          display: block;
          position: absolute;
          bottom: -11px;
          left: 0;
          width: 100%;
          height: 2px;
          background: #1f1f1f;
          border-radius: 2px;
        }

        &.active,
        &:hover {
          font-weight: 500;
          font-family: PingFangSC-Medium, PingFang SC;

          &::after {
            content: "";
            display: block;
            position: absolute;
            bottom: 8px;
            left: 0;
            width: 100%;
            height: 2px;
            background: #1f1f1f;
            border-radius: 2px;
          }
        }
      }
    }

    .header-right {
      color: #1f1f1f;

      .vip-btn,
      .collect-btn {
        color: #1f1f1f;
        line-height: 60px;

        img {
          margin-top: 22px;
        }
      }

      .collect-btn {
        img {
          @include wh(16px, 16px);
        }
      }

      .login-btn {
        color: #1f1f1f;
      }
    }
  }

  .icon-box {
    float: left;
    padding-top: 20px;
    cursor: pointer;
    padding-left: 30px;
    padding-right: 40px;
    padding-bottom: 21px;
    position: relative;

    img {
      width: 100%;
    }

    &:hover {
      ul {
        display: block;
      }
    }
  }

  .search-box {
    position: relative;
    height: 100%;
    float: left;
    width: calc(100% - 655px);
  }
}

.userProtocol-mask {
  position: fixed;
  box-sizing: content-box;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, .5);
  z-index: 999999;
  @include flex(center, center);
}

.userProtocol {
  width: 60%;
  position: fixed;
  left: 20%;
  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
  height: 600px;
  background-color: #fff;

  .com-userProtocol {
    height: 100%;
    padding: 60px 0;
    overflow-y: scroll;
  }

  .com-userProtocol .protocoltitle {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff;

    h2 {
      font-weight: 700;
      text-align: center;
      text-align: center;
      font-size: 20px;
      line-height: 30px;
    }

    i {
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 16px;
      color: #45b7ec;
      cursor: pointer;
    }
  }

  .com-userProtocol p {
    line-height: 30px;
    text-indent: 2rem;
    margin-bottom: 10px;
  }

  .com-userProtocol .item {
    margin-bottom: 10px;
  }

  .com-userProtocol .item .title {
    background: #f0f0f0;
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    border: 1px #e0e0e0 solid;
  }

  .com-userProtocol .item .font {
    padding: 10px;
    line-height: 30px;
    background: #f9f9f9;
    border: 1px #f0f0f0 solid;
    border-top: 0;
  }
}
</style>
